import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DenialTypeInfo, DenyDialogOptions } from './deny-dialog';


@Component({
  selector: 'app-deny-dialog',
  templateUrl: './deny-dialog.component.html',
  styleUrls: ['./deny-dialog.component.scss']
})
export class DenyDialogComponent {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    DenialTypes?: DenialTypeInfo[];
    Denial: any = {
        DenialNote: null,
        DenialType: null,
    };

    constructor(
        private dialogRef: MatDialogRef<DenyDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public opts: DenyDialogOptions,
    ) {
        const self = this;
        self.TitleText = opts.TitleText || 'Information Requested...';
        self.MessageText = opts.MessageText || '';
        self.OKText = opts.OKText || 'OK';
        self.CancelText = opts.CancelText || 'Cancel';
        self.DenialTypes = opts.DenialTypes || [];
    }

    CancelHandler(): void {
        this.dialogRef.close(null);
    }

    OKHandler(): void {
        const self = this;
        self.dialogRef.close(
            {
                DenialTypeID: (self.Denial.DenialType != null ? self.Denial.DenialType.DenialTypeID : null),
                DenialNote: (self.Denial.DenialType && self.Denial.DenialType.RequiresNote === true ? self.Denial.DenialNote : self.Denial.DenialType.Description),
            }
        );
    }

}